// source: seed.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.seed.AddModelRequest', null, global);
goog.exportSymbol('proto.seed.BulkRequest', null, global);
goog.exportSymbol('proto.seed.BulkRequest.RequestTypeCase', null, global);
goog.exportSymbol('proto.seed.BulkRequestList', null, global);
goog.exportSymbol('proto.seed.BulkResponse', null, global);
goog.exportSymbol('proto.seed.Empty', null, global);
goog.exportSymbol('proto.seed.HealthResponse', null, global);
goog.exportSymbol('proto.seed.HealthResponse.Status', null, global);
goog.exportSymbol('proto.seed.LocalPathBulkRequest', null, global);
goog.exportSymbol('proto.seed.ModelConfigEntry', null, global);
goog.exportSymbol('proto.seed.ModelConfigList', null, global);
goog.exportSymbol('proto.seed.ModelManagementResponse', null, global);
goog.exportSymbol('proto.seed.OutputType', null, global);
goog.exportSymbol('proto.seed.Request', null, global);
goog.exportSymbol('proto.seed.Response', null, global);
goog.exportSymbol('proto.seed.S3BulkRequest', null, global);
goog.exportSymbol('proto.seed.TaskType', null, global);
goog.exportSymbol('proto.seed.VideoConfig', null, global);
goog.exportSymbol('proto.seed.VideoFileRequest', null, global);
goog.exportSymbol('proto.seed.VideoFileRequest.SourceCase', null, global);
goog.exportSymbol('proto.seed.VideoFileResult', null, global);
goog.exportSymbol('proto.seed.VideoFileResult.ResultCase', null, global);
goog.exportSymbol('proto.seed.VideoFrame', null, global);
goog.exportSymbol('proto.seed.VideoFrameResult', null, global);
goog.exportSymbol('proto.seed.VideoOutputMode', null, global);
goog.exportSymbol('proto.seed.VideoProcessingMode', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.seed.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.seed.Request.repeatedFields_, null);
};
goog.inherits(proto.seed.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.seed.Request.displayName = 'proto.seed.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.seed.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.seed.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.seed.Response.displayName = 'proto.seed.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.seed.S3BulkRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.seed.S3BulkRequest.repeatedFields_, null);
};
goog.inherits(proto.seed.S3BulkRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.seed.S3BulkRequest.displayName = 'proto.seed.S3BulkRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.seed.LocalPathBulkRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.seed.LocalPathBulkRequest.repeatedFields_, null);
};
goog.inherits(proto.seed.LocalPathBulkRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.seed.LocalPathBulkRequest.displayName = 'proto.seed.LocalPathBulkRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.seed.BulkRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.seed.BulkRequest.oneofGroups_);
};
goog.inherits(proto.seed.BulkRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.seed.BulkRequest.displayName = 'proto.seed.BulkRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.seed.BulkRequestList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.seed.BulkRequestList.repeatedFields_, null);
};
goog.inherits(proto.seed.BulkRequestList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.seed.BulkRequestList.displayName = 'proto.seed.BulkRequestList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.seed.BulkResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.seed.BulkResponse.repeatedFields_, null);
};
goog.inherits(proto.seed.BulkResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.seed.BulkResponse.displayName = 'proto.seed.BulkResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.seed.VideoFrame = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.seed.VideoFrame, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.seed.VideoFrame.displayName = 'proto.seed.VideoFrame';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.seed.VideoFrameResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.seed.VideoFrameResult.repeatedFields_, null);
};
goog.inherits(proto.seed.VideoFrameResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.seed.VideoFrameResult.displayName = 'proto.seed.VideoFrameResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.seed.VideoFileResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.seed.VideoFileResult.oneofGroups_);
};
goog.inherits(proto.seed.VideoFileResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.seed.VideoFileResult.displayName = 'proto.seed.VideoFileResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.seed.VideoFileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.seed.VideoFileRequest.repeatedFields_, proto.seed.VideoFileRequest.oneofGroups_);
};
goog.inherits(proto.seed.VideoFileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.seed.VideoFileRequest.displayName = 'proto.seed.VideoFileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.seed.VideoConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.seed.VideoConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.seed.VideoConfig.displayName = 'proto.seed.VideoConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.seed.Empty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.seed.Empty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.seed.Empty.displayName = 'proto.seed.Empty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.seed.ModelConfigEntry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.seed.ModelConfigEntry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.seed.ModelConfigEntry.displayName = 'proto.seed.ModelConfigEntry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.seed.ModelConfigList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.seed.ModelConfigList.repeatedFields_, null);
};
goog.inherits(proto.seed.ModelConfigList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.seed.ModelConfigList.displayName = 'proto.seed.ModelConfigList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.seed.AddModelRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.seed.AddModelRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.seed.AddModelRequest.displayName = 'proto.seed.AddModelRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.seed.ModelManagementResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.seed.ModelManagementResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.seed.ModelManagementResponse.displayName = 'proto.seed.ModelManagementResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.seed.HealthResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.seed.HealthResponse.repeatedFields_, null);
};
goog.inherits(proto.seed.HealthResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.seed.HealthResponse.displayName = 'proto.seed.HealthResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.seed.Request.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.seed.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.seed.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.seed.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    media: msg.getMedia_asB64(),
    type: jspb.Message.getFieldWithDefault(msg, 3, 0),
    userId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, undefined) : [],
    requestedOutputsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    model: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.seed.Request}
 */
proto.seed.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.seed.Request;
  return proto.seed.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.seed.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.seed.Request}
 */
proto.seed.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setMedia(value);
      break;
    case 3:
      var value = /** @type {!proto.seed.TaskType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 5:
      var value = msg.getMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 6:
      var values = /** @type {!Array<!proto.seed.OutputType>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addRequestedOutputs(values[i]);
      }
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.seed.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.seed.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.seed.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMedia_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getRequestedOutputsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      6,
      f
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.seed.Request.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.Request} returns this
 */
proto.seed.Request.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes media = 2;
 * @return {string}
 */
proto.seed.Request.prototype.getMedia = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes media = 2;
 * This is a type-conversion wrapper around `getMedia()`
 * @return {string}
 */
proto.seed.Request.prototype.getMedia_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getMedia()));
};


/**
 * optional bytes media = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMedia()`
 * @return {!Uint8Array}
 */
proto.seed.Request.prototype.getMedia_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getMedia()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.seed.Request} returns this
 */
proto.seed.Request.prototype.setMedia = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional TaskType type = 3;
 * @return {!proto.seed.TaskType}
 */
proto.seed.Request.prototype.getType = function() {
  return /** @type {!proto.seed.TaskType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.seed.TaskType} value
 * @return {!proto.seed.Request} returns this
 */
proto.seed.Request.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string user_id = 4;
 * @return {string}
 */
proto.seed.Request.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.Request} returns this
 */
proto.seed.Request.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * map<string, string> metadata = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.seed.Request.prototype.getMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.seed.Request} returns this
 */
proto.seed.Request.prototype.clearMetadataMap = function() {
  this.getMetadataMap().clear();
  return this;
};


/**
 * repeated OutputType requested_outputs = 6;
 * @return {!Array<!proto.seed.OutputType>}
 */
proto.seed.Request.prototype.getRequestedOutputsList = function() {
  return /** @type {!Array<!proto.seed.OutputType>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<!proto.seed.OutputType>} value
 * @return {!proto.seed.Request} returns this
 */
proto.seed.Request.prototype.setRequestedOutputsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {!proto.seed.OutputType} value
 * @param {number=} opt_index
 * @return {!proto.seed.Request} returns this
 */
proto.seed.Request.prototype.addRequestedOutputs = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.seed.Request} returns this
 */
proto.seed.Request.prototype.clearRequestedOutputsList = function() {
  return this.setRequestedOutputsList([]);
};


/**
 * optional string model = 7;
 * @return {string}
 */
proto.seed.Request.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.Request} returns this
 */
proto.seed.Request.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.seed.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.seed.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.seed.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    predictOutput: jspb.Message.getFieldWithDefault(msg, 1, ""),
    response: jspb.Message.getFieldWithDefault(msg, 2, ""),
    status: jspb.Message.getFieldWithDefault(msg, 3, ""),
    requestId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    statusCode: jspb.Message.getFieldWithDefault(msg, 5, 0),
    metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.seed.Response}
 */
proto.seed.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.seed.Response;
  return proto.seed.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.seed.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.seed.Response}
 */
proto.seed.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPredictOutput(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setResponse(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatusCode(value);
      break;
    case 6:
      var value = msg.getMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.seed.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.seed.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.seed.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPredictOutput();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getResponse();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatusCode();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string predict_output = 1;
 * @return {string}
 */
proto.seed.Response.prototype.getPredictOutput = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.Response} returns this
 */
proto.seed.Response.prototype.setPredictOutput = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string response = 2;
 * @return {string}
 */
proto.seed.Response.prototype.getResponse = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.Response} returns this
 */
proto.seed.Response.prototype.setResponse = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string status = 3;
 * @return {string}
 */
proto.seed.Response.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.Response} returns this
 */
proto.seed.Response.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string request_id = 4;
 * @return {string}
 */
proto.seed.Response.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.Response} returns this
 */
proto.seed.Response.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 status_code = 5;
 * @return {number}
 */
proto.seed.Response.prototype.getStatusCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.seed.Response} returns this
 */
proto.seed.Response.prototype.setStatusCode = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * map<string, string> metadata = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.seed.Response.prototype.getMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.seed.Response} returns this
 */
proto.seed.Response.prototype.clearMetadataMap = function() {
  this.getMetadataMap().clear();
  return this;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.seed.S3BulkRequest.repeatedFields_ = [11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.seed.S3BulkRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.seed.S3BulkRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.seed.S3BulkRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.S3BulkRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    mediaS3Uri: jspb.Message.getFieldWithDefault(msg, 3, ""),
    modelS3Uri: jspb.Message.getFieldWithDefault(msg, 4, ""),
    modelConfigS3Uri: jspb.Message.getFieldWithDefault(msg, 5, ""),
    normalization: jspb.Message.getFieldWithDefault(msg, 6, ""),
    targetTileWidth: jspb.Message.getFieldWithDefault(msg, 7, 0),
    targetTileHeight: jspb.Message.getFieldWithDefault(msg, 8, 0),
    outputS3Uri: jspb.Message.getFieldWithDefault(msg, 9, ""),
    type: jspb.Message.getFieldWithDefault(msg, 10, 0),
    requestedOutputsList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
    metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.seed.S3BulkRequest}
 */
proto.seed.S3BulkRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.seed.S3BulkRequest;
  return proto.seed.S3BulkRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.seed.S3BulkRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.seed.S3BulkRequest}
 */
proto.seed.S3BulkRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMediaS3Uri(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelS3Uri(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelConfigS3Uri(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setNormalization(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTargetTileWidth(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTargetTileHeight(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setOutputS3Uri(value);
      break;
    case 10:
      var value = /** @type {!proto.seed.TaskType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 11:
      var values = /** @type {!Array<!proto.seed.OutputType>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addRequestedOutputs(values[i]);
      }
      break;
    case 12:
      var value = msg.getMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.seed.S3BulkRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.seed.S3BulkRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.seed.S3BulkRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.S3BulkRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMediaS3Uri();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getModelS3Uri();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getModelConfigS3Uri();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNormalization();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTargetTileWidth();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getTargetTileHeight();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getOutputS3Uri();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getRequestedOutputsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      11,
      f
    );
  }
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(12, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.seed.S3BulkRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.S3BulkRequest} returns this
 */
proto.seed.S3BulkRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.seed.S3BulkRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.S3BulkRequest} returns this
 */
proto.seed.S3BulkRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string media_s3_uri = 3;
 * @return {string}
 */
proto.seed.S3BulkRequest.prototype.getMediaS3Uri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.S3BulkRequest} returns this
 */
proto.seed.S3BulkRequest.prototype.setMediaS3Uri = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string model_s3_uri = 4;
 * @return {string}
 */
proto.seed.S3BulkRequest.prototype.getModelS3Uri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.S3BulkRequest} returns this
 */
proto.seed.S3BulkRequest.prototype.setModelS3Uri = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string model_config_s3_uri = 5;
 * @return {string}
 */
proto.seed.S3BulkRequest.prototype.getModelConfigS3Uri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.S3BulkRequest} returns this
 */
proto.seed.S3BulkRequest.prototype.setModelConfigS3Uri = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string normalization = 6;
 * @return {string}
 */
proto.seed.S3BulkRequest.prototype.getNormalization = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.S3BulkRequest} returns this
 */
proto.seed.S3BulkRequest.prototype.setNormalization = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional uint32 target_tile_width = 7;
 * @return {number}
 */
proto.seed.S3BulkRequest.prototype.getTargetTileWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.seed.S3BulkRequest} returns this
 */
proto.seed.S3BulkRequest.prototype.setTargetTileWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint32 target_tile_height = 8;
 * @return {number}
 */
proto.seed.S3BulkRequest.prototype.getTargetTileHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.seed.S3BulkRequest} returns this
 */
proto.seed.S3BulkRequest.prototype.setTargetTileHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string output_s3_uri = 9;
 * @return {string}
 */
proto.seed.S3BulkRequest.prototype.getOutputS3Uri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.S3BulkRequest} returns this
 */
proto.seed.S3BulkRequest.prototype.setOutputS3Uri = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional TaskType type = 10;
 * @return {!proto.seed.TaskType}
 */
proto.seed.S3BulkRequest.prototype.getType = function() {
  return /** @type {!proto.seed.TaskType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.seed.TaskType} value
 * @return {!proto.seed.S3BulkRequest} returns this
 */
proto.seed.S3BulkRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * repeated OutputType requested_outputs = 11;
 * @return {!Array<!proto.seed.OutputType>}
 */
proto.seed.S3BulkRequest.prototype.getRequestedOutputsList = function() {
  return /** @type {!Array<!proto.seed.OutputType>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<!proto.seed.OutputType>} value
 * @return {!proto.seed.S3BulkRequest} returns this
 */
proto.seed.S3BulkRequest.prototype.setRequestedOutputsList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {!proto.seed.OutputType} value
 * @param {number=} opt_index
 * @return {!proto.seed.S3BulkRequest} returns this
 */
proto.seed.S3BulkRequest.prototype.addRequestedOutputs = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.seed.S3BulkRequest} returns this
 */
proto.seed.S3BulkRequest.prototype.clearRequestedOutputsList = function() {
  return this.setRequestedOutputsList([]);
};


/**
 * map<string, string> metadata = 12;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.seed.S3BulkRequest.prototype.getMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 12, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.seed.S3BulkRequest} returns this
 */
proto.seed.S3BulkRequest.prototype.clearMetadataMap = function() {
  this.getMetadataMap().clear();
  return this;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.seed.LocalPathBulkRequest.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.seed.LocalPathBulkRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.seed.LocalPathBulkRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.seed.LocalPathBulkRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.LocalPathBulkRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    localDirectoryPath: jspb.Message.getFieldWithDefault(msg, 3, ""),
    normalization: jspb.Message.getFieldWithDefault(msg, 4, ""),
    targetTileWidth: jspb.Message.getFieldWithDefault(msg, 5, 0),
    targetTileHeight: jspb.Message.getFieldWithDefault(msg, 6, 0),
    type: jspb.Message.getFieldWithDefault(msg, 7, 0),
    requestedOutputsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.seed.LocalPathBulkRequest}
 */
proto.seed.LocalPathBulkRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.seed.LocalPathBulkRequest;
  return proto.seed.LocalPathBulkRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.seed.LocalPathBulkRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.seed.LocalPathBulkRequest}
 */
proto.seed.LocalPathBulkRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocalDirectoryPath(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNormalization(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTargetTileWidth(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTargetTileHeight(value);
      break;
    case 7:
      var value = /** @type {!proto.seed.TaskType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 8:
      var values = /** @type {!Array<!proto.seed.OutputType>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addRequestedOutputs(values[i]);
      }
      break;
    case 9:
      var value = msg.getMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.seed.LocalPathBulkRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.seed.LocalPathBulkRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.seed.LocalPathBulkRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.LocalPathBulkRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLocalDirectoryPath();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getNormalization();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTargetTileWidth();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getTargetTileHeight();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getRequestedOutputsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      8,
      f
    );
  }
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(9, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.seed.LocalPathBulkRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.LocalPathBulkRequest} returns this
 */
proto.seed.LocalPathBulkRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.seed.LocalPathBulkRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.LocalPathBulkRequest} returns this
 */
proto.seed.LocalPathBulkRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string local_directory_path = 3;
 * @return {string}
 */
proto.seed.LocalPathBulkRequest.prototype.getLocalDirectoryPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.LocalPathBulkRequest} returns this
 */
proto.seed.LocalPathBulkRequest.prototype.setLocalDirectoryPath = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string normalization = 4;
 * @return {string}
 */
proto.seed.LocalPathBulkRequest.prototype.getNormalization = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.LocalPathBulkRequest} returns this
 */
proto.seed.LocalPathBulkRequest.prototype.setNormalization = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 target_tile_width = 5;
 * @return {number}
 */
proto.seed.LocalPathBulkRequest.prototype.getTargetTileWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.seed.LocalPathBulkRequest} returns this
 */
proto.seed.LocalPathBulkRequest.prototype.setTargetTileWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 target_tile_height = 6;
 * @return {number}
 */
proto.seed.LocalPathBulkRequest.prototype.getTargetTileHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.seed.LocalPathBulkRequest} returns this
 */
proto.seed.LocalPathBulkRequest.prototype.setTargetTileHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional TaskType type = 7;
 * @return {!proto.seed.TaskType}
 */
proto.seed.LocalPathBulkRequest.prototype.getType = function() {
  return /** @type {!proto.seed.TaskType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.seed.TaskType} value
 * @return {!proto.seed.LocalPathBulkRequest} returns this
 */
proto.seed.LocalPathBulkRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * repeated OutputType requested_outputs = 8;
 * @return {!Array<!proto.seed.OutputType>}
 */
proto.seed.LocalPathBulkRequest.prototype.getRequestedOutputsList = function() {
  return /** @type {!Array<!proto.seed.OutputType>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<!proto.seed.OutputType>} value
 * @return {!proto.seed.LocalPathBulkRequest} returns this
 */
proto.seed.LocalPathBulkRequest.prototype.setRequestedOutputsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {!proto.seed.OutputType} value
 * @param {number=} opt_index
 * @return {!proto.seed.LocalPathBulkRequest} returns this
 */
proto.seed.LocalPathBulkRequest.prototype.addRequestedOutputs = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.seed.LocalPathBulkRequest} returns this
 */
proto.seed.LocalPathBulkRequest.prototype.clearRequestedOutputsList = function() {
  return this.setRequestedOutputsList([]);
};


/**
 * map<string, string> metadata = 9;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.seed.LocalPathBulkRequest.prototype.getMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 9, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.seed.LocalPathBulkRequest} returns this
 */
proto.seed.LocalPathBulkRequest.prototype.clearMetadataMap = function() {
  this.getMetadataMap().clear();
  return this;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.seed.BulkRequest.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.seed.BulkRequest.RequestTypeCase = {
  REQUEST_TYPE_NOT_SET: 0,
  REQUEST_LIST: 1,
  S3_REQUEST: 2,
  LOCAL_PATH_REQUEST: 3
};

/**
 * @return {proto.seed.BulkRequest.RequestTypeCase}
 */
proto.seed.BulkRequest.prototype.getRequestTypeCase = function() {
  return /** @type {proto.seed.BulkRequest.RequestTypeCase} */(jspb.Message.computeOneofCase(this, proto.seed.BulkRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.seed.BulkRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.seed.BulkRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.seed.BulkRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.BulkRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestList: (f = msg.getRequestList()) && proto.seed.BulkRequestList.toObject(includeInstance, f),
    s3Request: (f = msg.getS3Request()) && proto.seed.S3BulkRequest.toObject(includeInstance, f),
    localPathRequest: (f = msg.getLocalPathRequest()) && proto.seed.LocalPathBulkRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.seed.BulkRequest}
 */
proto.seed.BulkRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.seed.BulkRequest;
  return proto.seed.BulkRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.seed.BulkRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.seed.BulkRequest}
 */
proto.seed.BulkRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.seed.BulkRequestList;
      reader.readMessage(value,proto.seed.BulkRequestList.deserializeBinaryFromReader);
      msg.setRequestList(value);
      break;
    case 2:
      var value = new proto.seed.S3BulkRequest;
      reader.readMessage(value,proto.seed.S3BulkRequest.deserializeBinaryFromReader);
      msg.setS3Request(value);
      break;
    case 3:
      var value = new proto.seed.LocalPathBulkRequest;
      reader.readMessage(value,proto.seed.LocalPathBulkRequest.deserializeBinaryFromReader);
      msg.setLocalPathRequest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.seed.BulkRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.seed.BulkRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.seed.BulkRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.BulkRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestList();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.seed.BulkRequestList.serializeBinaryToWriter
    );
  }
  f = message.getS3Request();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.seed.S3BulkRequest.serializeBinaryToWriter
    );
  }
  f = message.getLocalPathRequest();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.seed.LocalPathBulkRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional BulkRequestList request_list = 1;
 * @return {?proto.seed.BulkRequestList}
 */
proto.seed.BulkRequest.prototype.getRequestList = function() {
  return /** @type{?proto.seed.BulkRequestList} */ (
    jspb.Message.getWrapperField(this, proto.seed.BulkRequestList, 1));
};


/**
 * @param {?proto.seed.BulkRequestList|undefined} value
 * @return {!proto.seed.BulkRequest} returns this
*/
proto.seed.BulkRequest.prototype.setRequestList = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.seed.BulkRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.seed.BulkRequest} returns this
 */
proto.seed.BulkRequest.prototype.clearRequestList = function() {
  return this.setRequestList(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.seed.BulkRequest.prototype.hasRequestList = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional S3BulkRequest s3_request = 2;
 * @return {?proto.seed.S3BulkRequest}
 */
proto.seed.BulkRequest.prototype.getS3Request = function() {
  return /** @type{?proto.seed.S3BulkRequest} */ (
    jspb.Message.getWrapperField(this, proto.seed.S3BulkRequest, 2));
};


/**
 * @param {?proto.seed.S3BulkRequest|undefined} value
 * @return {!proto.seed.BulkRequest} returns this
*/
proto.seed.BulkRequest.prototype.setS3Request = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.seed.BulkRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.seed.BulkRequest} returns this
 */
proto.seed.BulkRequest.prototype.clearS3Request = function() {
  return this.setS3Request(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.seed.BulkRequest.prototype.hasS3Request = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional LocalPathBulkRequest local_path_request = 3;
 * @return {?proto.seed.LocalPathBulkRequest}
 */
proto.seed.BulkRequest.prototype.getLocalPathRequest = function() {
  return /** @type{?proto.seed.LocalPathBulkRequest} */ (
    jspb.Message.getWrapperField(this, proto.seed.LocalPathBulkRequest, 3));
};


/**
 * @param {?proto.seed.LocalPathBulkRequest|undefined} value
 * @return {!proto.seed.BulkRequest} returns this
*/
proto.seed.BulkRequest.prototype.setLocalPathRequest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.seed.BulkRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.seed.BulkRequest} returns this
 */
proto.seed.BulkRequest.prototype.clearLocalPathRequest = function() {
  return this.setLocalPathRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.seed.BulkRequest.prototype.hasLocalPathRequest = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.seed.BulkRequestList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.seed.BulkRequestList.prototype.toObject = function(opt_includeInstance) {
  return proto.seed.BulkRequestList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.seed.BulkRequestList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.BulkRequestList.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestsList: jspb.Message.toObjectList(msg.getRequestsList(),
    proto.seed.Request.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.seed.BulkRequestList}
 */
proto.seed.BulkRequestList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.seed.BulkRequestList;
  return proto.seed.BulkRequestList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.seed.BulkRequestList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.seed.BulkRequestList}
 */
proto.seed.BulkRequestList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.seed.Request;
      reader.readMessage(value,proto.seed.Request.deserializeBinaryFromReader);
      msg.addRequests(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.seed.BulkRequestList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.seed.BulkRequestList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.seed.BulkRequestList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.BulkRequestList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.seed.Request.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Request requests = 1;
 * @return {!Array<!proto.seed.Request>}
 */
proto.seed.BulkRequestList.prototype.getRequestsList = function() {
  return /** @type{!Array<!proto.seed.Request>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.seed.Request, 1));
};


/**
 * @param {!Array<!proto.seed.Request>} value
 * @return {!proto.seed.BulkRequestList} returns this
*/
proto.seed.BulkRequestList.prototype.setRequestsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.seed.Request=} opt_value
 * @param {number=} opt_index
 * @return {!proto.seed.Request}
 */
proto.seed.BulkRequestList.prototype.addRequests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.seed.Request, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.seed.BulkRequestList} returns this
 */
proto.seed.BulkRequestList.prototype.clearRequestsList = function() {
  return this.setRequestsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.seed.BulkResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.seed.BulkResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.seed.BulkResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.seed.BulkResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.BulkResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    responsesList: jspb.Message.toObjectList(msg.getResponsesList(),
    proto.seed.Response.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.seed.BulkResponse}
 */
proto.seed.BulkResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.seed.BulkResponse;
  return proto.seed.BulkResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.seed.BulkResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.seed.BulkResponse}
 */
proto.seed.BulkResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.seed.Response;
      reader.readMessage(value,proto.seed.Response.deserializeBinaryFromReader);
      msg.addResponses(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.seed.BulkResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.seed.BulkResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.seed.BulkResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.BulkResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResponsesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.seed.Response.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Response responses = 1;
 * @return {!Array<!proto.seed.Response>}
 */
proto.seed.BulkResponse.prototype.getResponsesList = function() {
  return /** @type{!Array<!proto.seed.Response>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.seed.Response, 1));
};


/**
 * @param {!Array<!proto.seed.Response>} value
 * @return {!proto.seed.BulkResponse} returns this
*/
proto.seed.BulkResponse.prototype.setResponsesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.seed.Response=} opt_value
 * @param {number=} opt_index
 * @return {!proto.seed.Response}
 */
proto.seed.BulkResponse.prototype.addResponses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.seed.Response, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.seed.BulkResponse} returns this
 */
proto.seed.BulkResponse.prototype.clearResponsesList = function() {
  return this.setResponsesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.seed.VideoFrame.prototype.toObject = function(opt_includeInstance) {
  return proto.seed.VideoFrame.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.seed.VideoFrame} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.VideoFrame.toObject = function(includeInstance, msg) {
  var f, obj = {
    videoId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    frameIndex: jspb.Message.getFieldWithDefault(msg, 2, 0),
    frameData: msg.getFrameData_asB64(),
    timestamp: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.seed.VideoFrame}
 */
proto.seed.VideoFrame.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.seed.VideoFrame;
  return proto.seed.VideoFrame.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.seed.VideoFrame} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.seed.VideoFrame}
 */
proto.seed.VideoFrame.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVideoId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFrameIndex(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setFrameData(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTimestamp(value);
      break;
    case 5:
      var value = msg.getMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.seed.VideoFrame.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.seed.VideoFrame.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.seed.VideoFrame} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.VideoFrame.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVideoId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFrameIndex();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getFrameData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string video_id = 1;
 * @return {string}
 */
proto.seed.VideoFrame.prototype.getVideoId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.VideoFrame} returns this
 */
proto.seed.VideoFrame.prototype.setVideoId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 frame_index = 2;
 * @return {number}
 */
proto.seed.VideoFrame.prototype.getFrameIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.seed.VideoFrame} returns this
 */
proto.seed.VideoFrame.prototype.setFrameIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bytes frame_data = 3;
 * @return {string}
 */
proto.seed.VideoFrame.prototype.getFrameData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes frame_data = 3;
 * This is a type-conversion wrapper around `getFrameData()`
 * @return {string}
 */
proto.seed.VideoFrame.prototype.getFrameData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getFrameData()));
};


/**
 * optional bytes frame_data = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFrameData()`
 * @return {!Uint8Array}
 */
proto.seed.VideoFrame.prototype.getFrameData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getFrameData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.seed.VideoFrame} returns this
 */
proto.seed.VideoFrame.prototype.setFrameData = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};


/**
 * optional double timestamp = 4;
 * @return {number}
 */
proto.seed.VideoFrame.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.seed.VideoFrame} returns this
 */
proto.seed.VideoFrame.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * map<string, string> metadata = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.seed.VideoFrame.prototype.getMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.seed.VideoFrame} returns this
 */
proto.seed.VideoFrame.prototype.clearMetadataMap = function() {
  this.getMetadataMap().clear();
  return this;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.seed.VideoFrameResult.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.seed.VideoFrameResult.prototype.toObject = function(opt_includeInstance) {
  return proto.seed.VideoFrameResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.seed.VideoFrameResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.VideoFrameResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    videoId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    frameIndex: jspb.Message.getFieldWithDefault(msg, 2, 0),
    predictOutput: jspb.Message.getFieldWithDefault(msg, 3, ""),
    status: jspb.Message.getFieldWithDefault(msg, 4, ""),
    timestamp: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, undefined) : [],
    isKeyframe: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    interpolatedFramesList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.seed.VideoFrameResult}
 */
proto.seed.VideoFrameResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.seed.VideoFrameResult;
  return proto.seed.VideoFrameResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.seed.VideoFrameResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.seed.VideoFrameResult}
 */
proto.seed.VideoFrameResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVideoId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFrameIndex(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPredictOutput(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTimestamp(value);
      break;
    case 6:
      var value = msg.getMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsKeyframe(value);
      break;
    case 8:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addInterpolatedFrames(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.seed.VideoFrameResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.seed.VideoFrameResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.seed.VideoFrameResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.VideoFrameResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVideoId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFrameIndex();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPredictOutput();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getIsKeyframe();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getInterpolatedFramesList();
  if (f.length > 0) {
    writer.writePackedInt32(
      8,
      f
    );
  }
};


/**
 * optional string video_id = 1;
 * @return {string}
 */
proto.seed.VideoFrameResult.prototype.getVideoId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.VideoFrameResult} returns this
 */
proto.seed.VideoFrameResult.prototype.setVideoId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 frame_index = 2;
 * @return {number}
 */
proto.seed.VideoFrameResult.prototype.getFrameIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.seed.VideoFrameResult} returns this
 */
proto.seed.VideoFrameResult.prototype.setFrameIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string predict_output = 3;
 * @return {string}
 */
proto.seed.VideoFrameResult.prototype.getPredictOutput = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.VideoFrameResult} returns this
 */
proto.seed.VideoFrameResult.prototype.setPredictOutput = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string status = 4;
 * @return {string}
 */
proto.seed.VideoFrameResult.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.VideoFrameResult} returns this
 */
proto.seed.VideoFrameResult.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double timestamp = 5;
 * @return {number}
 */
proto.seed.VideoFrameResult.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.seed.VideoFrameResult} returns this
 */
proto.seed.VideoFrameResult.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * map<string, string> metadata = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.seed.VideoFrameResult.prototype.getMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.seed.VideoFrameResult} returns this
 */
proto.seed.VideoFrameResult.prototype.clearMetadataMap = function() {
  this.getMetadataMap().clear();
  return this;
};


/**
 * optional bool is_keyframe = 7;
 * @return {boolean}
 */
proto.seed.VideoFrameResult.prototype.getIsKeyframe = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.seed.VideoFrameResult} returns this
 */
proto.seed.VideoFrameResult.prototype.setIsKeyframe = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * repeated int32 interpolated_frames = 8;
 * @return {!Array<number>}
 */
proto.seed.VideoFrameResult.prototype.getInterpolatedFramesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.seed.VideoFrameResult} returns this
 */
proto.seed.VideoFrameResult.prototype.setInterpolatedFramesList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.seed.VideoFrameResult} returns this
 */
proto.seed.VideoFrameResult.prototype.addInterpolatedFrames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.seed.VideoFrameResult} returns this
 */
proto.seed.VideoFrameResult.prototype.clearInterpolatedFramesList = function() {
  return this.setInterpolatedFramesList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.seed.VideoFileResult.oneofGroups_ = [[4,5,6]];

/**
 * @enum {number}
 */
proto.seed.VideoFileResult.ResultCase = {
  RESULT_NOT_SET: 0,
  FILE_PATH: 4,
  S3_URI: 5,
  VIDEO_DATA: 6
};

/**
 * @return {proto.seed.VideoFileResult.ResultCase}
 */
proto.seed.VideoFileResult.prototype.getResultCase = function() {
  return /** @type {proto.seed.VideoFileResult.ResultCase} */(jspb.Message.computeOneofCase(this, proto.seed.VideoFileResult.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.seed.VideoFileResult.prototype.toObject = function(opt_includeInstance) {
  return proto.seed.VideoFileResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.seed.VideoFileResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.VideoFileResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    videoId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, ""),
    message: jspb.Message.getFieldWithDefault(msg, 3, ""),
    filePath: jspb.Message.getFieldWithDefault(msg, 4, ""),
    s3Uri: jspb.Message.getFieldWithDefault(msg, 5, ""),
    videoData: msg.getVideoData_asB64(),
    metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, undefined) : [],
    totalFrames: jspb.Message.getFieldWithDefault(msg, 8, 0),
    processingTime: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.seed.VideoFileResult}
 */
proto.seed.VideoFileResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.seed.VideoFileResult;
  return proto.seed.VideoFileResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.seed.VideoFileResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.seed.VideoFileResult}
 */
proto.seed.VideoFileResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVideoId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilePath(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setS3Uri(value);
      break;
    case 6:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setVideoData(value);
      break;
    case 7:
      var value = msg.getMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalFrames(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProcessingTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.seed.VideoFileResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.seed.VideoFileResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.seed.VideoFileResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.VideoFileResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVideoId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeBytes(
      6,
      f
    );
  }
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(7, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getTotalFrames();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getProcessingTime();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
};


/**
 * optional string video_id = 1;
 * @return {string}
 */
proto.seed.VideoFileResult.prototype.getVideoId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.VideoFileResult} returns this
 */
proto.seed.VideoFileResult.prototype.setVideoId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string status = 2;
 * @return {string}
 */
proto.seed.VideoFileResult.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.VideoFileResult} returns this
 */
proto.seed.VideoFileResult.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.seed.VideoFileResult.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.VideoFileResult} returns this
 */
proto.seed.VideoFileResult.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string file_path = 4;
 * @return {string}
 */
proto.seed.VideoFileResult.prototype.getFilePath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.VideoFileResult} returns this
 */
proto.seed.VideoFileResult.prototype.setFilePath = function(value) {
  return jspb.Message.setOneofField(this, 4, proto.seed.VideoFileResult.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.seed.VideoFileResult} returns this
 */
proto.seed.VideoFileResult.prototype.clearFilePath = function() {
  return jspb.Message.setOneofField(this, 4, proto.seed.VideoFileResult.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.seed.VideoFileResult.prototype.hasFilePath = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string s3_uri = 5;
 * @return {string}
 */
proto.seed.VideoFileResult.prototype.getS3Uri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.VideoFileResult} returns this
 */
proto.seed.VideoFileResult.prototype.setS3Uri = function(value) {
  return jspb.Message.setOneofField(this, 5, proto.seed.VideoFileResult.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.seed.VideoFileResult} returns this
 */
proto.seed.VideoFileResult.prototype.clearS3Uri = function() {
  return jspb.Message.setOneofField(this, 5, proto.seed.VideoFileResult.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.seed.VideoFileResult.prototype.hasS3Uri = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bytes video_data = 6;
 * @return {string}
 */
proto.seed.VideoFileResult.prototype.getVideoData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * optional bytes video_data = 6;
 * This is a type-conversion wrapper around `getVideoData()`
 * @return {string}
 */
proto.seed.VideoFileResult.prototype.getVideoData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getVideoData()));
};


/**
 * optional bytes video_data = 6;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getVideoData()`
 * @return {!Uint8Array}
 */
proto.seed.VideoFileResult.prototype.getVideoData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getVideoData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.seed.VideoFileResult} returns this
 */
proto.seed.VideoFileResult.prototype.setVideoData = function(value) {
  return jspb.Message.setOneofField(this, 6, proto.seed.VideoFileResult.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.seed.VideoFileResult} returns this
 */
proto.seed.VideoFileResult.prototype.clearVideoData = function() {
  return jspb.Message.setOneofField(this, 6, proto.seed.VideoFileResult.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.seed.VideoFileResult.prototype.hasVideoData = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * map<string, string> metadata = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.seed.VideoFileResult.prototype.getMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.seed.VideoFileResult} returns this
 */
proto.seed.VideoFileResult.prototype.clearMetadataMap = function() {
  this.getMetadataMap().clear();
  return this;
};


/**
 * optional int32 total_frames = 8;
 * @return {number}
 */
proto.seed.VideoFileResult.prototype.getTotalFrames = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.seed.VideoFileResult} returns this
 */
proto.seed.VideoFileResult.prototype.setTotalFrames = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional double processing_time = 9;
 * @return {number}
 */
proto.seed.VideoFileResult.prototype.getProcessingTime = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.seed.VideoFileResult} returns this
 */
proto.seed.VideoFileResult.prototype.setProcessingTime = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.seed.VideoFileRequest.repeatedFields_ = [8];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.seed.VideoFileRequest.oneofGroups_ = [[3,4,5]];

/**
 * @enum {number}
 */
proto.seed.VideoFileRequest.SourceCase = {
  SOURCE_NOT_SET: 0,
  FILE_PATH: 3,
  S3_URI: 4,
  VIDEO_DATA: 5
};

/**
 * @return {proto.seed.VideoFileRequest.SourceCase}
 */
proto.seed.VideoFileRequest.prototype.getSourceCase = function() {
  return /** @type {proto.seed.VideoFileRequest.SourceCase} */(jspb.Message.computeOneofCase(this, proto.seed.VideoFileRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.seed.VideoFileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.seed.VideoFileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.seed.VideoFileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.VideoFileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    filePath: jspb.Message.getFieldWithDefault(msg, 3, ""),
    s3Uri: jspb.Message.getFieldWithDefault(msg, 4, ""),
    videoData: msg.getVideoData_asB64(),
    type: jspb.Message.getFieldWithDefault(msg, 6, 0),
    mode: jspb.Message.getFieldWithDefault(msg, 7, 0),
    requestedOutputsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, undefined) : [],
    model: jspb.Message.getFieldWithDefault(msg, 10, ""),
    config: (f = msg.getConfig()) && proto.seed.VideoConfig.toObject(includeInstance, f),
    outputMode: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.seed.VideoFileRequest}
 */
proto.seed.VideoFileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.seed.VideoFileRequest;
  return proto.seed.VideoFileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.seed.VideoFileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.seed.VideoFileRequest}
 */
proto.seed.VideoFileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilePath(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setS3Uri(value);
      break;
    case 5:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setVideoData(value);
      break;
    case 6:
      var value = /** @type {!proto.seed.TaskType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 7:
      var value = /** @type {!proto.seed.VideoProcessingMode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 8:
      var values = /** @type {!Array<!proto.seed.OutputType>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addRequestedOutputs(values[i]);
      }
      break;
    case 9:
      var value = msg.getMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 11:
      var value = new proto.seed.VideoConfig;
      reader.readMessage(value,proto.seed.VideoConfig.deserializeBinaryFromReader);
      msg.setConfig(value);
      break;
    case 12:
      var value = /** @type {!proto.seed.VideoOutputMode} */ (reader.readEnum());
      msg.setOutputMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.seed.VideoFileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.seed.VideoFileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.seed.VideoFileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.VideoFileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeBytes(
      5,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getRequestedOutputsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      8,
      f
    );
  }
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(9, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getConfig();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.seed.VideoConfig.serializeBinaryToWriter
    );
  }
  f = message.getOutputMode();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.seed.VideoFileRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.VideoFileRequest} returns this
 */
proto.seed.VideoFileRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.seed.VideoFileRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.VideoFileRequest} returns this
 */
proto.seed.VideoFileRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string file_path = 3;
 * @return {string}
 */
proto.seed.VideoFileRequest.prototype.getFilePath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.VideoFileRequest} returns this
 */
proto.seed.VideoFileRequest.prototype.setFilePath = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.seed.VideoFileRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.seed.VideoFileRequest} returns this
 */
proto.seed.VideoFileRequest.prototype.clearFilePath = function() {
  return jspb.Message.setOneofField(this, 3, proto.seed.VideoFileRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.seed.VideoFileRequest.prototype.hasFilePath = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string s3_uri = 4;
 * @return {string}
 */
proto.seed.VideoFileRequest.prototype.getS3Uri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.VideoFileRequest} returns this
 */
proto.seed.VideoFileRequest.prototype.setS3Uri = function(value) {
  return jspb.Message.setOneofField(this, 4, proto.seed.VideoFileRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.seed.VideoFileRequest} returns this
 */
proto.seed.VideoFileRequest.prototype.clearS3Uri = function() {
  return jspb.Message.setOneofField(this, 4, proto.seed.VideoFileRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.seed.VideoFileRequest.prototype.hasS3Uri = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bytes video_data = 5;
 * @return {string}
 */
proto.seed.VideoFileRequest.prototype.getVideoData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * optional bytes video_data = 5;
 * This is a type-conversion wrapper around `getVideoData()`
 * @return {string}
 */
proto.seed.VideoFileRequest.prototype.getVideoData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getVideoData()));
};


/**
 * optional bytes video_data = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getVideoData()`
 * @return {!Uint8Array}
 */
proto.seed.VideoFileRequest.prototype.getVideoData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getVideoData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.seed.VideoFileRequest} returns this
 */
proto.seed.VideoFileRequest.prototype.setVideoData = function(value) {
  return jspb.Message.setOneofField(this, 5, proto.seed.VideoFileRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.seed.VideoFileRequest} returns this
 */
proto.seed.VideoFileRequest.prototype.clearVideoData = function() {
  return jspb.Message.setOneofField(this, 5, proto.seed.VideoFileRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.seed.VideoFileRequest.prototype.hasVideoData = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional TaskType type = 6;
 * @return {!proto.seed.TaskType}
 */
proto.seed.VideoFileRequest.prototype.getType = function() {
  return /** @type {!proto.seed.TaskType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.seed.TaskType} value
 * @return {!proto.seed.VideoFileRequest} returns this
 */
proto.seed.VideoFileRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional VideoProcessingMode mode = 7;
 * @return {!proto.seed.VideoProcessingMode}
 */
proto.seed.VideoFileRequest.prototype.getMode = function() {
  return /** @type {!proto.seed.VideoProcessingMode} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.seed.VideoProcessingMode} value
 * @return {!proto.seed.VideoFileRequest} returns this
 */
proto.seed.VideoFileRequest.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * repeated OutputType requested_outputs = 8;
 * @return {!Array<!proto.seed.OutputType>}
 */
proto.seed.VideoFileRequest.prototype.getRequestedOutputsList = function() {
  return /** @type {!Array<!proto.seed.OutputType>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<!proto.seed.OutputType>} value
 * @return {!proto.seed.VideoFileRequest} returns this
 */
proto.seed.VideoFileRequest.prototype.setRequestedOutputsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {!proto.seed.OutputType} value
 * @param {number=} opt_index
 * @return {!proto.seed.VideoFileRequest} returns this
 */
proto.seed.VideoFileRequest.prototype.addRequestedOutputs = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.seed.VideoFileRequest} returns this
 */
proto.seed.VideoFileRequest.prototype.clearRequestedOutputsList = function() {
  return this.setRequestedOutputsList([]);
};


/**
 * map<string, string> metadata = 9;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.seed.VideoFileRequest.prototype.getMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 9, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.seed.VideoFileRequest} returns this
 */
proto.seed.VideoFileRequest.prototype.clearMetadataMap = function() {
  this.getMetadataMap().clear();
  return this;
};


/**
 * optional string model = 10;
 * @return {string}
 */
proto.seed.VideoFileRequest.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.VideoFileRequest} returns this
 */
proto.seed.VideoFileRequest.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional VideoConfig config = 11;
 * @return {?proto.seed.VideoConfig}
 */
proto.seed.VideoFileRequest.prototype.getConfig = function() {
  return /** @type{?proto.seed.VideoConfig} */ (
    jspb.Message.getWrapperField(this, proto.seed.VideoConfig, 11));
};


/**
 * @param {?proto.seed.VideoConfig|undefined} value
 * @return {!proto.seed.VideoFileRequest} returns this
*/
proto.seed.VideoFileRequest.prototype.setConfig = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.seed.VideoFileRequest} returns this
 */
proto.seed.VideoFileRequest.prototype.clearConfig = function() {
  return this.setConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.seed.VideoFileRequest.prototype.hasConfig = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional VideoOutputMode output_mode = 12;
 * @return {!proto.seed.VideoOutputMode}
 */
proto.seed.VideoFileRequest.prototype.getOutputMode = function() {
  return /** @type {!proto.seed.VideoOutputMode} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.seed.VideoOutputMode} value
 * @return {!proto.seed.VideoFileRequest} returns this
 */
proto.seed.VideoFileRequest.prototype.setOutputMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.seed.VideoConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.seed.VideoConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.seed.VideoConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.VideoConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    batchSize: jspb.Message.getFieldWithDefault(msg, 1, 0),
    keyframeThreshold: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    enableTemporalSmoothing: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    fpsOverride: jspb.Message.getFieldWithDefault(msg, 4, 0),
    maxFrames: jspb.Message.getFieldWithDefault(msg, 5, 0),
    skipFrames: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.seed.VideoConfig}
 */
proto.seed.VideoConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.seed.VideoConfig;
  return proto.seed.VideoConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.seed.VideoConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.seed.VideoConfig}
 */
proto.seed.VideoConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBatchSize(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setKeyframeThreshold(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableTemporalSmoothing(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFpsOverride(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxFrames(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSkipFrames(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.seed.VideoConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.seed.VideoConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.seed.VideoConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.VideoConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBatchSize();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getKeyframeThreshold();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getEnableTemporalSmoothing();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getFpsOverride();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getMaxFrames();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getSkipFrames();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional int32 batch_size = 1;
 * @return {number}
 */
proto.seed.VideoConfig.prototype.getBatchSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.seed.VideoConfig} returns this
 */
proto.seed.VideoConfig.prototype.setBatchSize = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional float keyframe_threshold = 2;
 * @return {number}
 */
proto.seed.VideoConfig.prototype.getKeyframeThreshold = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.seed.VideoConfig} returns this
 */
proto.seed.VideoConfig.prototype.setKeyframeThreshold = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional bool enable_temporal_smoothing = 3;
 * @return {boolean}
 */
proto.seed.VideoConfig.prototype.getEnableTemporalSmoothing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.seed.VideoConfig} returns this
 */
proto.seed.VideoConfig.prototype.setEnableTemporalSmoothing = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional int32 fps_override = 4;
 * @return {number}
 */
proto.seed.VideoConfig.prototype.getFpsOverride = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.seed.VideoConfig} returns this
 */
proto.seed.VideoConfig.prototype.setFpsOverride = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 max_frames = 5;
 * @return {number}
 */
proto.seed.VideoConfig.prototype.getMaxFrames = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.seed.VideoConfig} returns this
 */
proto.seed.VideoConfig.prototype.setMaxFrames = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 skip_frames = 6;
 * @return {number}
 */
proto.seed.VideoConfig.prototype.getSkipFrames = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.seed.VideoConfig} returns this
 */
proto.seed.VideoConfig.prototype.setSkipFrames = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.seed.Empty.prototype.toObject = function(opt_includeInstance) {
  return proto.seed.Empty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.seed.Empty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.Empty.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.seed.Empty}
 */
proto.seed.Empty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.seed.Empty;
  return proto.seed.Empty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.seed.Empty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.seed.Empty}
 */
proto.seed.Empty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.seed.Empty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.seed.Empty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.seed.Empty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.Empty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.seed.ModelConfigEntry.prototype.toObject = function(opt_includeInstance) {
  return proto.seed.ModelConfigEntry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.seed.ModelConfigEntry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.ModelConfigEntry.toObject = function(includeInstance, msg) {
  var f, obj = {
    modelName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    modelPath: jspb.Message.getFieldWithDefault(msg, 2, ""),
    taskType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    jsonConfig: jspb.Message.getFieldWithDefault(msg, 4, ""),
    interSup: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    tileWidth: jspb.Message.getFieldWithDefault(msg, 6, 0),
    tileHeight: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.seed.ModelConfigEntry}
 */
proto.seed.ModelConfigEntry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.seed.ModelConfigEntry;
  return proto.seed.ModelConfigEntry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.seed.ModelConfigEntry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.seed.ModelConfigEntry}
 */
proto.seed.ModelConfigEntry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelPath(value);
      break;
    case 3:
      var value = /** @type {!proto.seed.TaskType} */ (reader.readEnum());
      msg.setTaskType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setJsonConfig(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInterSup(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTileWidth(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTileHeight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.seed.ModelConfigEntry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.seed.ModelConfigEntry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.seed.ModelConfigEntry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.ModelConfigEntry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getModelName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getModelPath();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTaskType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getJsonConfig();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getInterSup();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getTileWidth();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getTileHeight();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional string model_name = 1;
 * @return {string}
 */
proto.seed.ModelConfigEntry.prototype.getModelName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.ModelConfigEntry} returns this
 */
proto.seed.ModelConfigEntry.prototype.setModelName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string model_path = 2;
 * @return {string}
 */
proto.seed.ModelConfigEntry.prototype.getModelPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.ModelConfigEntry} returns this
 */
proto.seed.ModelConfigEntry.prototype.setModelPath = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional TaskType task_type = 3;
 * @return {!proto.seed.TaskType}
 */
proto.seed.ModelConfigEntry.prototype.getTaskType = function() {
  return /** @type {!proto.seed.TaskType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.seed.TaskType} value
 * @return {!proto.seed.ModelConfigEntry} returns this
 */
proto.seed.ModelConfigEntry.prototype.setTaskType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string json_config = 4;
 * @return {string}
 */
proto.seed.ModelConfigEntry.prototype.getJsonConfig = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.ModelConfigEntry} returns this
 */
proto.seed.ModelConfigEntry.prototype.setJsonConfig = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool inter_sup = 5;
 * @return {boolean}
 */
proto.seed.ModelConfigEntry.prototype.getInterSup = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.seed.ModelConfigEntry} returns this
 */
proto.seed.ModelConfigEntry.prototype.setInterSup = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional int32 tile_width = 6;
 * @return {number}
 */
proto.seed.ModelConfigEntry.prototype.getTileWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.seed.ModelConfigEntry} returns this
 */
proto.seed.ModelConfigEntry.prototype.setTileWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 tile_height = 7;
 * @return {number}
 */
proto.seed.ModelConfigEntry.prototype.getTileHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.seed.ModelConfigEntry} returns this
 */
proto.seed.ModelConfigEntry.prototype.setTileHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.seed.ModelConfigList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.seed.ModelConfigList.prototype.toObject = function(opt_includeInstance) {
  return proto.seed.ModelConfigList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.seed.ModelConfigList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.ModelConfigList.toObject = function(includeInstance, msg) {
  var f, obj = {
    configsList: jspb.Message.toObjectList(msg.getConfigsList(),
    proto.seed.ModelConfigEntry.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.seed.ModelConfigList}
 */
proto.seed.ModelConfigList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.seed.ModelConfigList;
  return proto.seed.ModelConfigList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.seed.ModelConfigList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.seed.ModelConfigList}
 */
proto.seed.ModelConfigList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.seed.ModelConfigEntry;
      reader.readMessage(value,proto.seed.ModelConfigEntry.deserializeBinaryFromReader);
      msg.addConfigs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.seed.ModelConfigList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.seed.ModelConfigList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.seed.ModelConfigList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.ModelConfigList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.seed.ModelConfigEntry.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ModelConfigEntry configs = 1;
 * @return {!Array<!proto.seed.ModelConfigEntry>}
 */
proto.seed.ModelConfigList.prototype.getConfigsList = function() {
  return /** @type{!Array<!proto.seed.ModelConfigEntry>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.seed.ModelConfigEntry, 1));
};


/**
 * @param {!Array<!proto.seed.ModelConfigEntry>} value
 * @return {!proto.seed.ModelConfigList} returns this
*/
proto.seed.ModelConfigList.prototype.setConfigsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.seed.ModelConfigEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.seed.ModelConfigEntry}
 */
proto.seed.ModelConfigList.prototype.addConfigs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.seed.ModelConfigEntry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.seed.ModelConfigList} returns this
 */
proto.seed.ModelConfigList.prototype.clearConfigsList = function() {
  return this.setConfigsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.seed.AddModelRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.seed.AddModelRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.seed.AddModelRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.AddModelRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    modelName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    modelS3Uri: jspb.Message.getFieldWithDefault(msg, 2, ""),
    jsonConfigS3Uri: jspb.Message.getFieldWithDefault(msg, 3, ""),
    taskType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    interSup: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    tileWidth: jspb.Message.getFieldWithDefault(msg, 6, 0),
    tileHeight: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.seed.AddModelRequest}
 */
proto.seed.AddModelRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.seed.AddModelRequest;
  return proto.seed.AddModelRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.seed.AddModelRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.seed.AddModelRequest}
 */
proto.seed.AddModelRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelS3Uri(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setJsonConfigS3Uri(value);
      break;
    case 4:
      var value = /** @type {!proto.seed.TaskType} */ (reader.readEnum());
      msg.setTaskType(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInterSup(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTileWidth(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTileHeight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.seed.AddModelRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.seed.AddModelRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.seed.AddModelRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.AddModelRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getModelName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getModelS3Uri();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getJsonConfigS3Uri();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTaskType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getInterSup();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getTileWidth();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getTileHeight();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional string model_name = 1;
 * @return {string}
 */
proto.seed.AddModelRequest.prototype.getModelName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.AddModelRequest} returns this
 */
proto.seed.AddModelRequest.prototype.setModelName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string model_s3_uri = 2;
 * @return {string}
 */
proto.seed.AddModelRequest.prototype.getModelS3Uri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.AddModelRequest} returns this
 */
proto.seed.AddModelRequest.prototype.setModelS3Uri = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string json_config_s3_uri = 3;
 * @return {string}
 */
proto.seed.AddModelRequest.prototype.getJsonConfigS3Uri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.AddModelRequest} returns this
 */
proto.seed.AddModelRequest.prototype.setJsonConfigS3Uri = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional TaskType task_type = 4;
 * @return {!proto.seed.TaskType}
 */
proto.seed.AddModelRequest.prototype.getTaskType = function() {
  return /** @type {!proto.seed.TaskType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.seed.TaskType} value
 * @return {!proto.seed.AddModelRequest} returns this
 */
proto.seed.AddModelRequest.prototype.setTaskType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional bool inter_sup = 5;
 * @return {boolean}
 */
proto.seed.AddModelRequest.prototype.getInterSup = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.seed.AddModelRequest} returns this
 */
proto.seed.AddModelRequest.prototype.setInterSup = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional int32 tile_width = 6;
 * @return {number}
 */
proto.seed.AddModelRequest.prototype.getTileWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.seed.AddModelRequest} returns this
 */
proto.seed.AddModelRequest.prototype.setTileWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 tile_height = 7;
 * @return {number}
 */
proto.seed.AddModelRequest.prototype.getTileHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.seed.AddModelRequest} returns this
 */
proto.seed.AddModelRequest.prototype.setTileHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.seed.ModelManagementResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.seed.ModelManagementResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.seed.ModelManagementResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.ModelManagementResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    message: jspb.Message.getFieldWithDefault(msg, 2, ""),
    currentConfigs: (f = msg.getCurrentConfigs()) && proto.seed.ModelConfigList.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.seed.ModelManagementResponse}
 */
proto.seed.ModelManagementResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.seed.ModelManagementResponse;
  return proto.seed.ModelManagementResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.seed.ModelManagementResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.seed.ModelManagementResponse}
 */
proto.seed.ModelManagementResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = new proto.seed.ModelConfigList;
      reader.readMessage(value,proto.seed.ModelConfigList.deserializeBinaryFromReader);
      msg.setCurrentConfigs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.seed.ModelManagementResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.seed.ModelManagementResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.seed.ModelManagementResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.ModelManagementResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCurrentConfigs();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.seed.ModelConfigList.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.seed.ModelManagementResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.seed.ModelManagementResponse} returns this
 */
proto.seed.ModelManagementResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.seed.ModelManagementResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.ModelManagementResponse} returns this
 */
proto.seed.ModelManagementResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ModelConfigList current_configs = 3;
 * @return {?proto.seed.ModelConfigList}
 */
proto.seed.ModelManagementResponse.prototype.getCurrentConfigs = function() {
  return /** @type{?proto.seed.ModelConfigList} */ (
    jspb.Message.getWrapperField(this, proto.seed.ModelConfigList, 3));
};


/**
 * @param {?proto.seed.ModelConfigList|undefined} value
 * @return {!proto.seed.ModelManagementResponse} returns this
*/
proto.seed.ModelManagementResponse.prototype.setCurrentConfigs = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.seed.ModelManagementResponse} returns this
 */
proto.seed.ModelManagementResponse.prototype.clearCurrentConfigs = function() {
  return this.setCurrentConfigs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.seed.ModelManagementResponse.prototype.hasCurrentConfigs = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.seed.HealthResponse.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.seed.HealthResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.seed.HealthResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.seed.HealthResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.HealthResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0),
    message: jspb.Message.getFieldWithDefault(msg, 2, ""),
    uptimeSeconds: jspb.Message.getFieldWithDefault(msg, 3, 0),
    detailsMap: (f = msg.getDetailsMap()) ? f.toObject(includeInstance, undefined) : [],
    loadedModels: jspb.Message.getFieldWithDefault(msg, 5, 0),
    modelNamesList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.seed.HealthResponse}
 */
proto.seed.HealthResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.seed.HealthResponse;
  return proto.seed.HealthResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.seed.HealthResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.seed.HealthResponse}
 */
proto.seed.HealthResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.seed.HealthResponse.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUptimeSeconds(value);
      break;
    case 4:
      var value = msg.getDetailsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLoadedModels(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addModelNames(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.seed.HealthResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.seed.HealthResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.seed.HealthResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.seed.HealthResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUptimeSeconds();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getDetailsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getLoadedModels();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getModelNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.seed.HealthResponse.Status = {
  UNKNOWN: 0,
  HEALTHY: 1,
  DEGRADED: 2,
  UNHEALTHY: 3
};

/**
 * optional Status status = 1;
 * @return {!proto.seed.HealthResponse.Status}
 */
proto.seed.HealthResponse.prototype.getStatus = function() {
  return /** @type {!proto.seed.HealthResponse.Status} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.seed.HealthResponse.Status} value
 * @return {!proto.seed.HealthResponse} returns this
 */
proto.seed.HealthResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.seed.HealthResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.seed.HealthResponse} returns this
 */
proto.seed.HealthResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 uptime_seconds = 3;
 * @return {number}
 */
proto.seed.HealthResponse.prototype.getUptimeSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.seed.HealthResponse} returns this
 */
proto.seed.HealthResponse.prototype.setUptimeSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * map<string, string> details = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.seed.HealthResponse.prototype.getDetailsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.seed.HealthResponse} returns this
 */
proto.seed.HealthResponse.prototype.clearDetailsMap = function() {
  this.getDetailsMap().clear();
  return this;
};


/**
 * optional int32 loaded_models = 5;
 * @return {number}
 */
proto.seed.HealthResponse.prototype.getLoadedModels = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.seed.HealthResponse} returns this
 */
proto.seed.HealthResponse.prototype.setLoadedModels = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * repeated string model_names = 6;
 * @return {!Array<string>}
 */
proto.seed.HealthResponse.prototype.getModelNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.seed.HealthResponse} returns this
 */
proto.seed.HealthResponse.prototype.setModelNamesList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.seed.HealthResponse} returns this
 */
proto.seed.HealthResponse.prototype.addModelNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.seed.HealthResponse} returns this
 */
proto.seed.HealthResponse.prototype.clearModelNamesList = function() {
  return this.setModelNamesList([]);
};


/**
 * @enum {number}
 */
proto.seed.TaskType = {
  UNKNOWN: 0,
  SEMANTIC_SEGMENTATION: 1,
  IMAGE_REGENERATION: 2,
  OBJECT_DETECTION: 3,
  DAMAGE_CLASSIFICATION: 4
};

/**
 * @enum {number}
 */
proto.seed.OutputType = {
  POLY: 0,
  PRED: 1,
  BLEND: 2,
  YOLO: 3
};

/**
 * @enum {number}
 */
proto.seed.VideoProcessingMode = {
  REALTIME: 0,
  THROUGHPUT: 1,
  ADAPTIVE: 2
};

/**
 * @enum {number}
 */
proto.seed.VideoOutputMode = {
  STREAM_FRAMES: 0,
  GENERATE_VIDEO: 1
};

goog.object.extend(exports, proto.seed);
